import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

export default function GuestJupasStorageModal({ open, reason, onProceed, onRegister, onLogin }) {
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  if (!open || typeof document === 'undefined') return null;

  const reasonText = reason === 'limit'
    ? t('jupa.guestStorageModal.limitReason')
    : reason === 'remove'
      ? t('jupa.guestStorageModal.removeReason')
      : t('jupa.guestStorageModal.leaveScoresReason');

  return createPortal(
    <div
      className="fixed inset-0 z-[150] flex items-center justify-center bg-black/55 px-4 py-8"
      role="presentation"
    >
      <section
        className="w-full max-w-lg rounded-2xl border border-edge bg-surface-elevated p-6 text-left shadow-2xl sm:p-7"
        role="dialog"
        aria-modal="true"
        aria-labelledby="guest-jupas-storage-title"
        aria-describedby="guest-jupas-storage-description"
      >
        <h2 id="guest-jupas-storage-title" className="text-xl font-bold text-ink sm:text-2xl">
          {t('jupa.guestStorageModal.title')}
        </h2>
        <div id="guest-jupas-storage-description" className="mt-3 space-y-3 text-sm leading-6 text-ink-muted">
          <p>{reasonText}</p>
          <ul className="list-disc space-y-1 pl-5">
            <li>{t('jupa.guestStorageModal.noScoreSaving')}</li>
            <li>{t('jupa.guestStorageModal.noProgrammeSaving')}</li>
            <li>{t('jupa.guestStorageModal.threeProgrammeLimit')}</li>
          </ul>
        </div>
        <div className="mt-6 grid gap-2 sm:grid-cols-3">
          <button
            type="button"
            onClick={onProceed}
            className="rounded-lg border border-edge-strong px-4 py-2.5 text-sm font-semibold text-ink transition-colors hover:bg-surface-muted focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            {t('jupa.guestStorageModal.proceed')}
          </button>
          <button
            type="button"
            onClick={onRegister}
            className="rounded-lg bg-primary px-4 py-2.5 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary-hover focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            {t('common.register')}
          </button>
          <button
            type="button"
            onClick={onLogin}
            className="rounded-lg border border-primary px-4 py-2.5 text-sm font-semibold text-primary transition-colors hover:bg-primary/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            {t('common.login')}
          </button>
        </div>
      </section>
    </div>,
    document.body
  );
}
